import {
  useAppDispatch,
  useAppSelector,
  useAppStore,
} from "@/store/store-hooks";
import { TreeData } from "@/utils/tree-generation/tree-data";
import { FaroTooltip, useDialog } from "@faro-lotv/flat-ui";
import { useTranslate } from "@faro-lotv/foreign-observers";
import { selectIElement } from "@faro-lotv/project-source";
import { useCallback, type JSX } from "react";
import { ProjectTreeActionButton } from "./project-tree-action-button";
import {
  disableScaleAreaMessage,
  useDisableCaptureTreeAlignment,
} from "./tree/cad-model-tree/use-disable-capture-tree-alignment";
import { redirectToFloorScalingTool } from "./tree/tree-context-menu/utils";

/**
 * @returns a button used in the project tree, to start the exclusive mode floor scale
 */
export function SetFloorScaleButton({
  id,
}: Pick<TreeData, "id">): JSX.Element | null {
  const dispatch = useAppDispatch();
  const store = useAppStore();
  const { createDialog } = useDialog();
  const floorElement = useAppSelector(selectIElement(id));

  const disableScaling = useDisableCaptureTreeAlignment(floorElement);

  const onClick = useCallback(() => {
    redirectToFloorScalingTool({
      elementID: id,
      state: store.getState(),
      createDialog,
      dispatch,
    });
  }, [createDialog, dispatch, id, store]);

  const translate = useTranslate();

  return (
    <FaroTooltip title={disableScaling && disableScaleAreaMessage}>
      <ProjectTreeActionButton
        disabled={disableScaling}
        name={translate("Set scale")}
        onClick={onClick}
      />
    </FaroTooltip>
  );
}
